import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import { GetAvailableVendorCompaniesCommand } from './vendor-company.commands';
import { GottenVendorCompaniesEvent } from './vendor-company.events';

@Injectable()
export class VendorCompanyEffects {
  prefix = 'vendor-company';
  getAvailableVendorCompaniesCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.getAvailableVendorCompaniesCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAvailableVendorCompaniesCommand,
      GottenVendorCompaniesEvent,
      this.prefix,
    );
  }
}
